
import { mapState } from 'vuex';
import { Vue } from 'vue-property-decorator';
import { VueConstructor } from 'vue';

const LeftNav = (Vue as VueConstructor<Vue>).extend({
  props: {
    mini: { type: Boolean },
    drawer: { type: Boolean },
    xsNavVisible: { type: Boolean },
    isAuthenticated: { type: Boolean },
    newMpCount: { type: Number },
    newLightningCount: { type: Number },
    newFieldOrderzCount: { type: Number },
    newImportCount: { type: Number },
  },

  computed: {
    ...mapState('userStore', {
      user: 'user',
    }),
    navModel: {
      get(): boolean {
        if (this.$vuetify.breakpoint.xs) {
          return this.xsNavVisible;
        } else {
          return this.drawer;
        }
      },
      set(value: boolean) {
        if (this.$vuetify.breakpoint.xs) {
          this.$emit('update:xsNavVisible', value);
        } else {
          this.$emit('update:drawer', value);
        }
      },
    },
  },
  
  methods: {
    closeDrawerOnMobile() {
      if (this.$vuetify.breakpoint.xs) {
        this.$emit('update:xsNavVisible', false);
      }
    },
    
    handleLogin() {
      this.closeDrawerOnMobile();
      this.$emit('login');
    },
    
    handleLogout() {
      this.closeDrawerOnMobile();
      this.$emit('logout');
    }
  }
});
export default LeftNav;
